var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 68,
    viewBox: "0 0 103 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7738 0C67.2524 0 60.1717 3.56142 54.9095 9.87354C51.4242 5.96466 46.8783 3.79306 42.0155 3.79306C33.5298 3.79306 26.2287 10.4671 23.8455 20.0077H19.9333C8.94035 20.0077 0 30.7788 0 44.0111C0 57.2433 8.94035 68 19.9333 68H74.7738C90.3402 68 103 52.7554 103 34.0072C103 15.2446 90.3402 0 74.7738 0ZM74.7738 61.1957H19.9333C12.095 61.1957 5.71686 53.4792 5.71686 43.9966C5.71686 34.5139 12.095 26.7975 19.9333 26.7975H26.1185C27.5236 26.7975 28.7083 25.5959 28.9425 23.96C30.017 16.2146 35.5272 10.5829 42.0155 10.5829C46.2171 10.5829 50.0742 12.9283 52.6089 17.0109C53.1462 17.865 53.9727 18.3717 54.8681 18.3862C55.7084 18.3862 56.6039 17.9229 57.1549 17.0832C61.4666 10.5395 67.8723 6.78987 74.7601 6.78987C87.1719 6.78987 97.2694 18.9943 97.2694 33.9928C97.2831 48.9913 87.1856 61.1957 74.7738 61.1957Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.9f8e33352ab3e26c3435d496479b7571.svg";
export { ForwardRef as ReactComponent };